export enum RewardsSecondaryFilterParams {
  Country = 'country',
  Category = 'category',
  Sort = 'sortOrder',
  SelectedCountry = 'selectedCountry',
  Prime = 'prime',
}
